import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { LoginFormComponent } from '../../components/login-form/login-form.component';
import { PasswordValidationComponent } from '../../components/password-validation/password-validation.component';
import { authModuleRoutes } from '../../routes/api-authorization-routes';
import { setContainerTypeAction } from '../../ngrx/actions/global.actions';
import { QueryParameterNames } from '../../models/ApiAuthorization.model';

// The main responsibility of this component is to handle the user's login process.
// This is the starting point for the login process. Any component that needs to authenticate
// a user can simply perform a redirect to this component with a returnUrl query parameter and
// let the component perform the login and return back to the return url.
@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    standalone: true,
    imports: [LoginFormComponent]
})
export class LoginComponent extends PasswordValidationComponent implements OnInit {

  loginForm: FormGroup = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email]),
    password: new FormControl('', [Validators.required, this.passwordValidation.bind(this)]),
    rememberMe: new FormControl(true)
  });

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router) {
      super();
    }

  async ngOnInit() {
    this.dispatch(setContainerTypeAction({ containerType: 'normal' }));
    const action = this.activatedRoute.snapshot.url[0];
    if (authModuleRoutes.register === action.path) {
      this.redirectToRegister();
    }
  }

  onLoginSuccess() {
    // Honor a returnUrl query param (e.g. from email links or guard redirects),
    // but only app-relative paths so a crafted link can't bounce users off-site.
    const returnUrl = this.activatedRoute.snapshot.queryParams[QueryParameterNames.ReturnUrl];
    if (returnUrl && returnUrl.startsWith('/') && !returnUrl.startsWith('//')) {
      this.router.navigateByUrl(returnUrl);
    } else {
      this.router.navigate(['/']);
    }
  }

  private redirectToRegister(): any {
    this.router.navigate(['/register']);
  }
}
